import { render, staticRenderFns } from "./UpdatedTimestampAuditExplainer.vue?vue&type=template&id=5a6c2cfb&"
import script from "./UpdatedTimestampAuditExplainer.vue?vue&type=script&lang=ts&"
export * from "./UpdatedTimestampAuditExplainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports